var map = {
	"./modulo_07.svg": 688,
	"./modulo_Avatar.svg": 689,
	"./modulo_Benefit.svg": 437,
	"./modulo_Boton.svg": 690,
	"./modulo_Flags.svg": 691,
	"./modulo_Gallery.svg": 692,
	"./modulo_HTML.svg": 693,
	"./modulo_Icon.svg": 694,
	"./modulo_Icons.svg": 695,
	"./modulo_Imagen.svg": 696,
	"./modulo_Lead.svg": 697,
	"./modulo_Leads.svg": 698,
	"./modulo_Line.svg": 699,
	"./modulo_Name.svg": 700,
	"./modulo_Parrafo.svg": 701,
	"./modulo_Parrafo_new.svg": 702,
	"./modulo_QRCode.svg": 703,
	"./modulo_Review.svg": 704,
	"./modulo_Reward.svg": 438,
	"./modulo_SaveDate.svg": 705,
	"./modulo_Social.svg": 706,
	"./modulo_Space.svg": 707,
	"./modulo_Star.svg": 708,
	"./modulo_Titulo.svg": 547,
	"./modulo_Ubicacion.svg": 709,
	"./modulo_VCF.svg": 710,
	"./modulo_Video.svg": 711,
	"./modulo_Whereby.svg": 712,
	"./modulo_Xai.svg": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;